import { HomePage } from "../pages/Home";
import { ImprintPage } from "../pages/Imprint";
import { PrivacyPage } from "../pages/Privacy";
import { Linkedin, Envelope, House, type Icon } from "react-bootstrap-icons";

export interface NavigationItem {
  key: string;
  title?: string;
  link?: string;
  component?: React.ReactElement;
  icon?: Icon;
  path?: string;
  onlyRoote?: boolean;
}

export const navigationItems: NavigationItem[] = [
  {
    key: "home",
    title: "Home",
    path: "/",
    icon: House,
    component: <HomePage />,
  },

  {
    key: "linkedin",
    title: "Linkedin",
    link: import.meta.env.VITE_CONTACT_LINKEDIN,
    icon: Linkedin,
  },
  {
    key: "email",
    title: "E-Mail",
    link: import.meta.env.VITE_CONTACT_EMAIL,
    icon: Envelope,
  },

  {
    onlyRoote: true,
    key: "imprint",
    path: "/imprint",
    component: <ImprintPage />,
  },
  {
    onlyRoote: true,
    key: "privacy",
    path: "/privacy",
    component: <PrivacyPage />,
  },
];
